import { render, staticRenderFns } from "./CancelDisableCard.vue?vue&type=template&id=56d13ab5&scoped=true&"
import script from "./CancelDisableCard.vue?vue&type=script&lang=js&"
export * from "./CancelDisableCard.vue?vue&type=script&lang=js&"
import style0 from "./CancelDisableCard.vue?vue&type=style&index=0&id=56d13ab5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56d13ab5",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCardActions,VCardText,VCol,VRow})
